import { render, staticRenderFns } from "./SubscriptionItems.vue?vue&type=template&id=129dbed0&"
import script from "./SubscriptionItems.vue?vue&type=script&lang=js&"
export * from "./SubscriptionItems.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports